import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Elevator extends Component {
  static propTypes = {
    showAt: PropTypes.number,
  }

  static defaultProps = {
    showAt: 200,
  }

  constructor(props) {
    super(props);
    this.state = { visible: false };
  }

  handleScroll = () => {
    if (window.scrollY < this.props.showAt && this.state.visible) {
      return this.setState({ startExit: true });
    }
    if (window.scrollY >= this.props.showAt && !this.state.visible) {
      return this.setState({ visible: true });
    }
  }

  // Avoid unnecessary updates that may cause the animation to flicker
  shouldComponentUpdate(nextProps, nextState) {
    return this.state.visible !== nextState.visible || this.state.startExit !== nextState.startExit;
  }

  componentDidMount() {
    $(window).on('scroll', this.handleScroll);
    this.handleScroll(); // In case the user doesn't start at the top of the page
  }

  componentWillUnmount() {
    $(window).off('scroll', this.handleScroll);
  }

  handleClick = (e) => {
    e.preventDefault();

    $('html, body').animate({ scrollTop: 0 }, 800);
    this.setState({ startExit: true });
  }

  render() {
    if (!this.state.visible) return null;

    if (this.state.startExit) {
      // Begin the exit animation and change state after it
      setTimeout(() => {
        this.setState({ startExit: false, visible: false });
      }, 1000);
    }

    const animationClass = this.state.startExit ? 'slideOutDown' : 'bounceInUp';

    // Right now this markup is specific for our layout with sidebars.
    // You can hide the extra markup behind a prop and remove the `Elevator--sidebar`
    // modifier if you need to use this in a different context.
    return (
      <div className="u-hidden lg:u-flex u-fixed u-bottom-0 u-w-2/3 u-justify-end">
        <div className="u-w-1/4 u-relative">
          <a className={`Elevator Elevator--sidebar animated ${animationClass}`} onClick={this.handleClick}>
            Scroll to top
          </a>
        </div>
      </div>
    );
  }
}
